import script from "./ListarCobrancas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCobrancas.vue?vue&type=script&setup=true&lang=js"

import "./ListarCobrancas.vue?vue&type=style&index=0&id=311813ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311813ac"]])

export default __exports__